import { render } from "./PR31-07262023.vue?vue&type=template&id=2128224a"
import script from "./PR31-07262023.vue?vue&type=script&lang=js"
export * from "./PR31-07262023.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__